import React from "react";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { Heart } from "lucide-react";
import { useLang } from "../i18n";

const CSR = {
  tr: [
    {
      id: 1,
      title: "Eğitime Destek",
      description: "Kurduğumuz burs programları ile her yıl yüzlerce üniversite öğrencisine destek oluyoruz.",
      image: "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcGFydG1lbnQlMjBidWlsZGluZ3xlbnwwfHx8fDE3ODk0ODM1MDN8MA&ixlib=rb-4.1.0&q=85&w=1200",
    },
    {
      id: 2,
      title: "Çevre ve Doğa",
      description: "Ağaçlandırma çalışmaları ve karbon ayak izini azaltan projelerle doğayı koruyoruz.",
      image: "https://images.unsplash.com/photo-1624204386084-dd8c05e32226?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBhcGFydG1lbnQlMjBidWlsZGluZ3xlbnwwfHx8fDE3ODk0ODM1MDN8MA&ixlib=rb-4.1.0&q=85&w=1200",
    },
    {
      id: 3,
      title: "Kültür ve Sanat",
      description: "Yerel sanatçıları destekliyor, kültürel mirası gelecek nesillere taşıyacak projelere sponsor oluyoruz.",
      image: "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjByZXNpZGVudGlhbCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODk0ODM1MDN8MA&ixlib=rb-4.1.0&q=85&w=1200",
    },
  ],
  en: [
    {
      id: 1,
      title: "Education Support",
      description: "Through our scholarship programs, we support hundreds of university students every year.",
      image: "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcGFydG1lbnQlMjBidWlsZGluZ3xlbnwwfHx8fDE3ODk0ODM1MDN8MA&ixlib=rb-4.1.0&q=85&w=1200",
    },
    {
      id: 2,
      title: "Environment & Nature",
      description: "We protect nature with reforestation programs and projects that reduce our carbon footprint.",
      image: "https://images.unsplash.com/photo-1624204386084-dd8c05e32226?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBhcGFydG1lbnQlMjBidWlsZGluZ3xlbnwwfHx8fDE3ODk0ODM1MDN8MA&ixlib=rb-4.1.0&q=85&w=1200",
    },
    {
      id: 3,
      title: "Culture & Arts",
      description: "We support local artists and sponsor projects that carry cultural heritage into future generations.",
      image: "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjByZXNpZGVudGlhbCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODk0ODM1MDN8MA&ixlib=rb-4.1.0&q=85&w=1200",
    },
  ],
};

const SosyalSorumluluk = () => {
  const { lang, t } = useLang();
  const list = CSR[lang];
  return (
    <main className="bg-white">
      <SEO title={t("csr.title")} description={t("csr.subtitle")} path="/sosyal-sorumluluk" />
      <PageHero kicker={t("csr.kicker")} title={t("csr.title")} subtitle={t("csr.subtitle")} />

      <section className="pb-20">
        <div className="max-w-[1400px] mx-auto px-6 space-y-8">
          {list.map((c, i) => (
            <div
              key={c.id}
              className={`grid md:grid-cols-2 gap-8 items-center ${i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""}`}
            >
              <div className="rounded-2xl overflow-hidden bg-neutral-100 aspect-[4/3]">
                <img src={c.image} alt={c.title} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" />
              </div>
              <div>
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#C9A24B]/15 text-[#8F6E1E] text-xs font-semibold">
                  <Heart className="w-3.5 h-3.5" /> {t("csr.badge")}
                </div>
                <h3 className="mt-4 text-2xl md:text-4xl font-black text-[#1a1a1a] leading-tight">{c.title}</h3>
                <p className="mt-4 text-neutral-600 text-[17px] leading-relaxed">{c.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default SosyalSorumluluk;
